export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const SET_IS_NEW_PASSWORD_FALSE = 'SET_IS_NEW_PASSWORD_FALSE';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGIN = 'USER_LOGIN';
export const SET_ACCOUNT_NOT_SETUP = 'SET_ACCOUNT_NOT_SETUP';
